import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ProductsSliderHeader from 'components/products-slider-header';
import looppa from 'looppa';
import { PRODUCT_LIST_PRODUCT_SLIDER } from 'tracking/constants';
import Slider from 'components/slider';
import ProductTile from 'components/product-tile';
import { Link } from 'react-router-dom';
import { Trans } from 'translations';
import Icon from 'components/icon';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import { getViewportData } from 'util/dom/mq';
import sliderConfig, { productTileAmounts } from './slider-config.js';

class ContentPageProductSlider extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        lead: PropTypes.string,
        link: PropTypes.string,
        appendPromotionTile: PropTypes.bool,
        products: PropTypes.array.isRequired,

        historyPush: PropTypes.func.isRequired,
        isMobile: PropTypes.bool.isRequired,
        isTouch: PropTypes.bool.isRequired,
        isTablet: PropTypes.bool.isRequired,
    };
    static defaultProps = {
        link: null,
        appendPromotionTile: true,
    };

    numberOfItems(maxItems, amountPerRow) {
        return amountPerRow - maxItems % amountPerRow;
    }

    get trimmedProducts() {
        let { products } = this.props;

        // Render a maximum of 4 rows in slider; row-size depends on the current viewport
        const amountPerRow = productTileAmounts[getViewportData().query];
        const maxItems = Math.min(amountPerRow * 4, products.length);

        // Add placeholders if there are not enough items to fill one row
        if (products.length < amountPerRow - 1) {
            const numberOfItems = this.numberOfItems(maxItems, amountPerRow);
            const placeholders = Array(numberOfItems).fill(null);
            products = products.slice(0, maxItems).concat(placeholders);
        }

        return products;
    }

    renderPromotionTile() {
        const { link, isMobile, historyPush } = this.props;
        return (
            <article
                onClick={() => {
                    // on mobile the whole tile surface should be a link
                    if (isMobile) {
                        historyPush(link);
                    }
                }}
                className="products-slider--show-promotions"
                key={'show-promotions'}
            >
                {link && <Link
                    to={link}
                    className="products-slider--show-promotions-text u-reset">
                    <Trans path={'categories.show_all'}/>
                </Link>}

                {link && <Link
                    to={link}
                    className="products-slider--show-promotions-icon u-reset">
                    <Icon symbol="productslider-right" size="medium"/>
                </Link>}
            </article>
        );
    }

    render() {
        const { title, lead, link, isMobile, appendPromotionTile, isTablet, isTouch } = this.props;
        return (
            <div className="contentpage-product-slider products-slider">
                <ProductsSliderHeader
                    title={title}
                    link={link}
                />

                {lead && <p className='contentpage-product-slider--lead' dangerouslySetInnerHTML={{ __html: lead }}/>}

                <Slider
                    useNativeScroll={isMobile || (isTablet && isTouch)}
                    facet={'topic-slider'}
                    updateOnInteraction={true}
                    config={sliderConfig}>
                    {looppa(this.trimmedProducts)((product, index) => (
                        <ProductTile
                            {...product}
                            position={index}
                            facet={product ? 'overview' : 'placeholder'}
                            tileFacet='contentpage'
                            list={PRODUCT_LIST_PRODUCT_SLIDER}
                            key={product && product.id ? product.id : index}/>
                    )).concat([appendPromotionTile ? this.renderPromotionTile() : null])}
                </Slider>
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        isMobile: 'viewport.isMobile',
        isTablet: 'viewport.isTablet',
        isTouch: 'viewport.touchevents',
        historyPush: 'router.history.push',
    }),
)(ContentPageProductSlider);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/contentpage-product-slider/index.js